module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/received-free-product-label-9cdd66e3d7c001745953e8f60b0c793b.svg";